import React from 'react'
import DeleteProyeccionExportador from './DeleteProyeccionExportador'

function OperacionesProyecciones (props) {
  const { proyeccion } = props

  return (
    <div style={{ display: 'flex' }}>
      <DeleteProyeccionExportador proyeccion={proyeccion} />
    </div>
  )
}

export default OperacionesProyecciones
